import React,{Fragment, useState, useEffect} from 'react';
import {useCookies} from 'react-cookie';
import { Link, Navigate, useNavigate } from "react-router-dom";
import axios from 'axios';



const NewOrderEmpty = () =>{
  const navigate = useNavigate();
  const [cookies] = useCookies(['user']);
  const [clientCookie, setClientCookie,removeClientCookie] = useCookies (['client']);
  const [isLoaded, setIsLoaded] = useState(false);

useEffect(()=>{
  const config = {
      headers: { Authorization: "Bearer 5|X4kcu2RRJQOFjOZxtMb16xzk5dM1hgSTKeAPS9Lp"}
    };
  axios.post('https://api.orders.e-interior.gr/api/order/create',{

        key: cookies.Token,
        invoice: 0,
        client_id: 0,
        extras:0,
        payment:0,
        status:"not_submitted_yet"
        },
        config
      )
      .then(function (response) {
        console.log(response.data);
        setClientCookie('OrderId',response.data.order_id,{path:'/'});
        navigate('../1');

      })
      .catch(function (error) {
        console.log(error);
      });
},[])

  return null;
}
export default NewOrderEmpty;
